import ReactDOM from "react-dom";
import "./App.scss";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ApolloProvider } from "@apollo/client";
import { client } from "./graphql/auth";
import { BrowserRouter } from "react-router-dom";
import CommonProvider from "./context/CommonContext";
import AuthProvider from "./context/AuthContext";
import "@fontsource/lexend";
import "@fontsource/lexend/100.css";
import "@fontsource/lexend/200.css";
import "@fontsource/lexend/300.css";
import "@fontsource/lexend/400.css";
import "@fontsource/lexend/500.css";
import "@fontsource/lexend/600.css";
import "@fontsource/lexend/700.css";
import { UserProvider } from "./context/UserContext";
import { CabinetProvider } from "./context/CabinetContext";

ReactDOM.render(
  <ApolloProvider client={client}>
    <BrowserRouter>
      <AuthProvider>
        <UserProvider>
          <CommonProvider>
            <CabinetProvider>
              <App />
            </CabinetProvider>
          </CommonProvider>
        </UserProvider>
      </AuthProvider>
    </BrowserRouter>
  </ApolloProvider>,
  document.getElementById("root")
);
reportWebVitals();
